import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { withStyles } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import RadioGroup from "../../components/material-ui/RadioGroup";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";

import {
  SettingsMenuTabs, BackendSettings, SelectModel,
  SimilaritySettings, ImportFromDCSettings,
  ImportFromSASettings,
}                                     from "../../pages/dashboard/SettingsDialog";

import { subDays } from "date-fns";

import {
  getRunConfigOption,
  showSuccess,
  showWarning,
  showError,
  isFileValidUTF8,
  isMaybeNLU as isNLU,
  isGAI,
  isASR,
  mapObject,
  filterObject,
  getProject,
  isMaybeNLU,
  isMaybeASR,
  lcfirst,
  qw,
  subtractObject,
  filterKeys,
  filterOutKeys,
}                                     from "../../../core/utils";
import {
  getData,
  uploadFile,
  postData,
  putData,
}                                     from "../../../core/fetchService";
import {
  getConfig,
  changeDataset,
  updateDataset,
  fetchBackends,
  getBackends,
}                                     from "../../../features/settings";
import {
  getTestModelIntentAcc,
  getTestModelSlotAcc,
  getTestModelWRR,
  getTestModelGenvAcc,
}                                     from "../../../db_models";

import IconButton                     from "../../components/material-ui/IconButton";
import NumberField                    from "../../components/material-ui/NumberField";
import Autocomplete                   from "../../components/material-ui/Autocomplete";

import Upload                         from "../../components/fieldUpload";
import CloseBar                       from "../../components/dialogCloseBar";
import DateTimeRange, {
  appendDateTimeParams
}                                     from "../../components/dateTimeRange";

import notBackdropClicked             from "../../components/helpers/notBackdropClicked";

import ComposerConfigDialog           from "./ComposerConfigDialog";


export const UploadVariant = Object.freeze({
  File: "file",
  Composer: "composer",
  SpeechAnalitycs: "analytics",
  Test: "test",
  Copy: "copy",
});

export const defaultDCImportConfig = Object.freeze({
  date_type: "absolute",
  startDate: subDays(new Date(), 1),
  endDate: new Date(),
  quantity: 1,
  period: "month",
  maxSize: 10000,
  role: "user",
  intent_slot: "dummy",
  ani: '',
  channel: '',
  first: true,
  glue: false,
  status: "auto",
  sanitize: false,
  update_intents: false,
  check_audio: true,
});

export const defaultSAImportConfig = Object.freeze({
  startDate: subDays(new Date(), 1),
  endDate: new Date(),
  maxSize: 10000,
  date_type: "absolute",
});

const styles = (theme) => ({
  dialogPaper: {
    minWidth: "600px",
  },
  paper: {
    padding: "8px",
    textAlign: "left",
  },
  radioGroup: {
    alignItems: 'baseline',
  },
  editLoadFromDCParamsRow: {
    marginTop: 10,
    display: 'flex',
    flexFlow: 'row nowrap',
    width: '95%',
  },
  smallTextField: {
    marginTop: 8,
    marginLeft: 10,
    height: "auto",
    width: "25%",
  },
  dateTextField: {
    height: "auto",
    width: "50%",
  },
  column: {
    flexBasis: "33.33%",
  },
  heading: {
    fontSize: "12",
  },
  gridList: {
    overflow: "hidden",
  },
  summary: {
    marginLeft: "20px",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  checkboxStart: {
    width: "35%",
    marginRight: "10px",
    whiteSpace: "nowrap",
  },
  checkboxLabelBeforeText: {
    fontSize: "0.9rem",
    marginTop: 19,
  },
  checkboxLabelBeforeRadio: {
    fontSize: "0.9rem",
    marginTop: 13,
    width: 65,
  },
  similarityConfigServerURL: {
    marginTop: 0, // overwrite style from BackendSettings
    marginBottom: 8+2*2, // Settings::dialogField + 2*GridItem padding
  },
});

const useStyles = makeStyles(styles);

const TabPanel = props => {
  const { children, value, index, ...other } = props;
  return (
    <div
      id={`simple-tabpanel-${index}`}
      hidden={value != index}
      {...other}
    >
      <Typography component='span'>
        {children}
      </Typography>
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const getUploadFlagValues = state => [0,1,2,3,4].map(i => state.tabValue == i);
const isMenuItemKey = (state, k) => state.tabValue == undefined && state.menuItemKey == k;

function EditDialog(props) {
  const {
    classes, state, setState, checkStatus, setStatusWaiting, adjustStatusTo,
    fetchProjectDatasets, selectedDataSetId, getClearState_2,
    projects, projectId, projectDatasets, lang,
  } = props;

  const { 
    rowId,
    isClone,
    dataSetName,
    description,
    unique,
    fileName,
    copyProps,
    testId,
    dcImportConfig,
    saImportConfig,
    csvSeparator,
    csvExtIdField,
    csvInputField,
    csvOutputField,
    csvUtterance,
    csvIntentField,
    csvConfidence,
    csvAudio,
    header,
    generationConfig,
    similarityConfig,
    autoannotnConfig,
    radioValueFileType,
    uploadProperties,
    annStatus,
  } = state;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const backends = useSelector(getBackends);

  const [actionDisabled, setActionDisabled] = useState();

  useEffect(() => {
    dispatch(fetchBackends());
  }, [])

  const defaultDatasetOptions = useRef({
    name: dataSetName,
    description,
    ...(rowId ? {} : { unique }),
    dcImportConfig,
    saImportConfig,
    project: projectId,
    generationConfig,
    similarityConfig,
    autoannotnConfig,
  })

  const [is_from_file, is_from_dc, is_from_sa, is_from_test, is_copy] = getUploadFlagValues(state);
  const is_generate = isMenuItemKey(state, 'item_from_llm');
  const is_similarity = isMenuItemKey(state, 'item_similarity');
  const is_autoannotn = isMenuItemKey(state, 'item_auto');
  const project = getProject(projects, projectId);
  const is_proj_nlu = isNLU(project);
  const is_proj_gen = isGAI(project);

  const importFromComposer = async (rowId, button) => {
    const query = new URLSearchParams();
    appendDateTimeParams(query, dcImportConfig);
    [ "status", "role", "intent_slot", "ani", "channel",
      "maxSize", "first", "glue", "sanitize", "update_intents", "check_audio" ]
      .forEach(k => query.append(k, dcImportConfig[k]));

    const url = `/api/dataset/${rowId}/import_from_dc?${query.toString()}`;
    return postData(url, {}, dispatch, data => {
      checkStatus([{ _id: rowId }]);
    }, {
      error_prefix: t('datasets.import_from_dc_error'),
    });
  };

  const importFromSpeechAnalytics = async (rowId, button) => {
    const query = new URLSearchParams();
    appendDateTimeParams(query, saImportConfig);
    [ "maxSize" ].forEach(k => query.append(k, saImportConfig[k]));

    const url = `/api/dataset/${rowId}/import_from_sa?${query.toString()}`;
    return postData(url, { /* TODO: analyticsConfig */ }, dispatch, data => {
      checkStatus([{ _id: rowId }]);
    }, {
      error_prefix: t('datasets.import_from_sa_error'),
    });
  };

  const uploadDataset = async rowId => {
    let formData = state.formData;
    if (!await isFileValidUTF8(formData.get('file'),
                               m => {showWarning(dispatch, t)(m); return true},
                               e => {showError(dispatch, t)(e);   return false}))
      return false;
    formData.append("project", projectId);
    dataSetName && formData.append("name", dataSetName);
    formData.append("description", description);
    formData.append("unique", unique);

    const encodeQueryData = data =>
      Object.keys(data)
        .map(key => encodeURIComponent(key) +"="+ encodeURIComponent(data[key]))
        .join("&");

    let queryString = {
      format: radioValueFileType,
      ...(is_proj_gen ? { type: 'generative' } : {}),
      ...uploadProperties,
      status: annStatus,
    };

    if (radioValueFileType == "csv") {
      const descr = {
        delimiter: csvSeparator,
        ...(is_proj_gen ? {
          id:     csvExtIdField,
          input:  csvInputField,
          output: csvOutputField,
        } : {
          text: csvUtterance,
          intent: csvIntentField,
        }),
        confidence: csvConfidence,
        ...(is_proj_gen ? {
        } : {
          audio: csvAudio,
        }),
        header: String(header || false),
      };

      queryString = { ...queryString, ...mapObject(descr, v => (v || '').trim()) };
    }

    const url = `/api/dataset/${rowId}/upload?`+ encodeQueryData(queryString);

    uploadFile(url, formData, dispatch, data => {
      checkStatus([{ _id: rowId }]);
    }, {
      t,
      message_prefix: 'datasets',
      error_prefix: t('datasets.upload_error'),
    });

    return true;
  }

  const saveDataset = async () => {
    if (rowId && fileName) {
        const dataset = projectDatasets.find(ds => ds._id == rowId);
        setStatusWaiting(dataset); // could have used 'Saving...' but just 'Waiting...' seems simpler
    }

    const datasetOptions = {
      name: dataSetName || fileName.replace(/.*[/\\]/).replace(/\.(json|txt|csv|tsv|xlsx?)$/, ''),
      description,
      ...(rowId ? {} : { unique }),
      project: projectId,
      dcImportConfig,
      saImportConfig,
      generationConfig,
      similarityConfig,
      autoannotnConfig,
      testId,
    }

    const dataset = rowId ? subtractObject(datasetOptions, defaultDatasetOptions.current) : datasetOptions;
    const sendData = rowId && !isClone ? putData : postData;

    return await sendData(
      '/api/dataset' + (isClone ? '/copy' : '') + (rowId ? '/'+ rowId : ''), { dataset }, dispatch, data => {
        /* When this request precedes the dataset loading request (/upload, /import_from_dc, /import_from_sa),
         * the dataset status blinks: X -> Waiting -> X(*) -> Preparing -> [next], where X is the initial status,
         * because this request returns (may return) X after Waiting has been sent.
         *
         * Therefore, we remove the (execution.)status field from the result (in case of successful request),
         * to avoid redundant changing status to X [marked with (*) above]
         */
        const adjust = rowId && fileName ? ({ project }) => {
          project.datasets = project.datasets.map(d => d._id == rowId? adjustStatusTo('Waiting...', d) : d);
        } : undefined;
        fetchProjectDatasets({ stat: false, adjust }).then(() => {
          // selects new (first) dataset if !selectedDataSetId else no-op
          dispatch(changeDataset(selectedDataSetId));
        });
        return data.dataset?._id;
      });
  };

  const copyDataset = () => {
    const query = new URLSearchParams();
    for (const name of ["keep_intents", "keep_entities"])
      query.append(name, copyProps[name]);
    for (const name of ["start", "end"])
      if (state.copySlice[name] !== '')
        query.append(name, state.copySlice[name]);
    return postData(`/api/dataset/${state.rowId}/copy?`+ query, {}, dispatch, data => {
      fetchProjectDatasets({ stat: false });
    });
  };

  const importFromTest = rowId => {
    const url = `/api/dataset/${rowId}/import_from_test`;
    const uploadProperties = filterObject(state.uploadProperties, Boolean);
    return postData(url, { test_id: state.testId, ...uploadProperties }, dispatch, data => {
      fetchProjectDatasets({ stat: false });
    });
  };

  const generateDataset = rowId => {
    return postData(`/api/dataset/${rowId}/generate`, {}, dispatch, data => {
      fetchProjectDatasets({ stat: false });
    });
  };

  const handleClose = async (isAccepted, button) => {
    if (isAccepted) {
      let rowIdForCopy = rowId;

      if (state.uploadVariant != UploadVariant.Copy) {
        setActionDisabled(true);

        const res = await saveDataset();
        if (res?.error) {
          setActionDisabled(false);
          return; // this error should have already been reported
        }
        if (button == 'saveDataset') {
          setState(getClearState_2());
          return;
        }
        rowIdForCopy = res;
      }

      if (state.tabValue != undefined)
        switch (state.uploadVariant) {
          case UploadVariant.File:
            if (state.formData && !await uploadDataset(rowIdForCopy))
                return false;
            break;

          case UploadVariant.Composer:        importFromComposer(rowIdForCopy, button); break;
          case UploadVariant.SpeechAnalitycs: importFromSpeechAnalytics(rowIdForCopy, button); break;
          case UploadVariant.Copy:            copyDataset(); break;
          case UploadVariant.Test:            importFromTest(rowIdForCopy); break;

          default: break; // avoid no-default-case warning
        }
      else if (is_generate)
        generateDataset(rowIdForCopy);
    }

    setState(getClearState_2());
  };

  const simConfKeys =  ['nlu_backend', 'model'];            // TODO: from dataset descr
  const autoConfKeys = ['nlu_backend', 'model'];            // TODO: save as above
  const genConfKeys =  ['nlu_backend', 'model', 'dataset']; // TODO: same as above

  // TODO: remove after EOL
  const is_field_old_name_server = (config, k) => k == 'nlu_backend' && config?.server;
  const is_field_set = config => k => config?.[k] || is_field_old_name_server(config, k);

  const GO_BUTTONS = [{
    id: 'save',
    cond: is_from_file && !fileName || is_copy,
    disabled: !dataSetName && !is_copy
  }, {
    id: 'load',
    cond: is_from_file && fileName || is_from_dc || is_from_sa || is_from_test,
    disabled: (is_from_dc || is_from_sa) && !dataSetName
    || is_from_file && radioValueFileType == "csv"
    && (!csvSeparator
        || is_proj_gen && !csvInputField
        || !is_proj_gen && !csvUtterance)
    || is_from_test && (!testId || !dataSetName),
  }, {
    id: 'generate',
    cond: is_generate,
    disabled: !dataSetName || !genConfKeys.every(is_field_set(generationConfig)),
  }, {
    id: 'save',
    cond: is_similarity,
    disabled: !dataSetName || !simConfKeys.every(is_field_set(similarityConfig)),
  }, {
    id: 'save',
    cond: is_autoannotn,
    disabled: !dataSetName || !autoConfKeys.every(is_field_set(autoannotnConfig)),
  }];

  return (
    <Dialog
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
      fullWidth={true}
      scroll="paper"
      open={true}
      onClose={notBackdropClicked(() => handleClose(false))}
      aria-labelledby="dialog-upload-title"
    >
      <CloseBar
        onClose={() => handleClose(false)}
        title={rowId ? ( isClone ? t("datasets.clone") : t("datasets.dataset_edit")) : t("datasets.dataset_upload")}
      />
      <DialogContent dividers={true}>
        <div style={{ display: 'flex' }}>
          <TextField
            id="dataSetName"
            label={t("common.name")}
            required
            size="small"
            variant="outlined"
            style={{ margin: "8px 0", flexGrow: 1 }}
            defaultValue={state.dataSetName}
            onChange={event => setState({ dataSetName: event.target.value })}
            autoFocus
          />
          <FormControlLabel
            label={t("datasets.unique")}
            style={{ marginLeft: 20, height: "auto" }}
            control={<Checkbox/>}
            disabled={Boolean(rowId)}
            checked={state.unique}
            onChange={event => setState({ unique: event.target.checked })}
          />
        </div>
        <TextField
          size="small"
          variant="outlined"
          fullWidth
          style={{ margin: "8px 0" }}
          id="description"
          label={t("common.description")}
          multiline
          rows="3"
          className={classes.textField}
          defaultValue={state.description}
          onChange={event => setState({ description: event.target.value })}
        />
        <DatasetSettings
          backends={backends}
          settings={state.similarityConfig}
          setSettings={(name, opts = {}) => data => {
            const value_obj = opts.is_direct ? data : { [name]: data.target.value };
            setState({ ...state, similarityConfig: { ...state.similarityConfig, ...value_obj }})
          }}
          {...{
            state, setState, is_proj_nlu, is_proj_gen,
            rowId, checkStatus, setStatusWaiting, adjustStatusTo,
            fetchProjectDatasets, selectedDataSetId, getClearState_2,
            projects, projectId, projectDatasets, lang,
          }}
        />
      </DialogContent>
      <DialogActions>
        <div style={{ marginLeft: "auto" }}>
          <Button onClick={() => handleClose(false)}                   color="primary">
            {t("common.cancel")}
          </Button>
          {rowId && !(is_similarity || is_autoannotn || is_from_file || is_from_test)
          && <Button onClick={() => handleClose(true, 'saveDataset')}                   color="primary">
              {t("common.save")}
            </Button>
          }
          {GO_BUTTONS.map(b => b.cond ? (
            <Button onClick={() => handleClose(true, b.id)}                 color="primary"
              key={b.id}
              disabled={b.disabled || actionDisabled}
            >
              {t("common."+ b.id)}
            </Button>
          ) : null)}
        </div>
      </DialogActions>
    </Dialog>
  );
}

function UploadProperties({ state, handleUploadPropertiesChange, only, is_proj_gen }) {
  const { t } = useTranslation();

  return is_proj_gen ? null : (
    <div style={{ marginTop: 10 }}>
      <FormControl component="fieldset">
        <FormGroup>
          {Object.keys(state.uploadProperties).filter(k => !only || only.includes(k))
              .map(name => (
                <FormControlLabel
                  key={name}
                  control={
                    <Checkbox
                      checked={state.uploadProperties[name]}
                      onChange={handleUploadPropertiesChange}
                      name={name}
                    />
                  }
                  label={t("datasets."+ name)}
                />
              ))}
        </FormGroup>
      </FormControl>
    </div>
  );
}

function DatasetSettings({ settings, setSettings, backends, ...props }) {
  const { is_proj_nlu, is_proj_gen, rowId, state, setState } = props;
  const { t } = useTranslation();
  const config = useSelector(getConfig);
  const classes = useStyles();

  const { server } = settings || {}; // TODO: remove after EOL
  const { nlu_backend } = settings || {};
  const initNLUConfigServer = backends?.find(b => b._id == nlu_backend)?.url || server;
  const [is_from_file] = getUploadFlagValues(state);

  const [menuItemKey, _setMenuItemKey] = useState(is_from_file || !config.enableImportFromDC
                                                  ? 'item_upload_file' : 'item_import_from_dc');
  const [nluConfigServer, _setNLUConfigServer] = useState(initNLUConfigServer);
  const setNLUConfigServer = v => { _setNLUConfigServer(v.url) };

  useEffect(() => {
    setNLUConfigServer({ url: initNLUConfigServer });
  }, [menuItemKey, backends]);

  const MENU = {
    upload: {
      is_group: true,
    },
    item_upload_file: {
      group: 'upload',
      props: { tabValue: 0, ...props },
      component: UploadDataset,
      fieldset_label: t('settings.menu_upload') +' '+ lcfirst(t('settings.menu_item_upload_file')),
    },
    item_import_from_dc: {
      group: 'upload',
      show_if: !is_proj_gen && Boolean(config.enableImportFromDC),
      props: { tabValue: 1, ...props },
      component: UploadDataset,
      fieldset_label: t('settings.fieldset_import_from_dc'),
    },
    item_import_from_sa: {
      group: 'upload',
      show_if: !is_proj_gen && Boolean(config.enableImportFromDC),
      props: { tabValue: 2, ...props },
      component: UploadDataset,
      fieldset_label: t('settings.fieldset_import_from_sa'),
    },
    item_from_dataset: {
      group: 'upload',
      show_if: getRunConfigOption('copyDatasetTab') && rowId,
      props: { tabValue: 3, ...props },
      component: UploadDataset,
    },
    item_from_test: {
      group: 'upload',
      show_if: is_proj_nlu || is_proj_gen,
      component: ImportFromTest,
      props: { tabValue: 3, is_proj_gen, ...props },
      fieldset_label: t('settings.menu_upload') +' '+ lcfirst(t('settings.menu_item_from_test')),
    },
    generate: {
      is_group: true,
    },
    item_from_llm: {
      group: 'generate',
      show_if: is_proj_nlu || is_proj_gen,
      component: DatasetGenerateSettings,
      props: { nluConfigServer, setNLUConfigServer, backends, menuItemKey, ...props },
    },
    settings: {
      is_group: true,
    },
    item_similarity: {
      group: 'settings',
      show_if: !is_proj_gen,
      component: DatasetSimilaritySettings,
      props: { nluConfigServer, setNLUConfigServer, backends, menuItemKey, ...props },
    },
    item_auto: {
      group: 'settings',
      component: DatasetAutoanntnSettings,
      props: { nluConfigServer, setNLUConfigServer, backends, menuItemKey, ...props },
    },
  };

  const setMenuItemKey = k => {
    if (['item_upload_file', 'item_import_from_dc', 'item_import_from_sa',
         'item_from_dataset', 'item_from_test'].includes(k)
    ) {
      const tabValue = MENU[k].props.tabValue;
      const uploadVariant = UploadVariant[Object.keys(UploadVariant)[tabValue] || 'File'];
      setState({ tabValue, uploadVariant });
    } else {
      setState({ tabValue: undefined, menuItemKey: k }); // 'menuItemKey' is needed for isMenuItemKey()
    }
    _setMenuItemKey(k);
  };

  const MENU_PROPS = mapObject(MENU, (m,k) => {
    // const name = m.id +'Config';  <-- not implemented
    return {
/*
      id: m.id,
      fields: m.fields,
      settings: settings?.[name],
      setSettings: (field_name, opts = {}) => data => {
        const value_obj = opts.is_direct ? data : { [field_name]: data.target.value };
        const other = (name == 'nluConfig' && field_name == 'server')
          ? { similarityConfig: { ...settings.similarityConfig, model: null, partition: null } }
          : {};
        setSettings({ ...settings, [name]: { ...settings[name], ...value_obj }, ...other });
      },
*/
      ...m.props,
    };
  });

  return SettingsMenuTabs(MENU, MENU_PROPS, { menuItemKey, setMenuItemKey });
}

function UploadDataset({
  tabValue,
  settings,
  setSettings,
  state,
  setState,
  rowId, checkStatus, setStatusWaiting, adjustStatusTo,
  fetchProjectDatasets, selectedDataSetId, getClearState_2,
  projects, projectId, projectDatasets, lang,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const config = useSelector(getConfig);

  const project = getProject(projects, projectId);
  const is_proj_gen = isGAI(project);
  const is_proj_asr = isASR(project);

  const {
    radioValueFileType,
    uploadProperties: _up,
    copyProps,
    dcImportConfig,
    saImportConfig,
  } = state;

  const uploadProperties = filterObject(_up, (_,k) =>
                                        (k != 'update_intents' || isMaybeNLU(project))
                                        && (k != 'check_audio' || isMaybeASR(project)));

  const handleChangeSwitch = (event) => {
    setState({
      radioValueFileType: event.target.value,
      annStatus: "auto",
    });
  };

  const handleCheckboxChange = (event, key) => {
    setState({
      [key]: {
        ...state[key],
        [event.target.name]: event.target.checked,
      },
    });
  };

  const handleUploadPropertiesChange = (event) => {
    handleCheckboxChange(event, 'uploadProperties');
  };

  const handleCopyPropertiesChange = (event) => {
    handleCheckboxChange(event, 'copyProps');
  };

  const onFileLoad = (fileName, formData) => {
    setState({ fileName, formData});
  };

  const handleCopySliceFill = (name, value) => {
    setState(prevState => ({
      copySlice: {
        ...prevState.copySlice,
        [name]: value,
      },
    }));
  };

  const handleNestedFormContentFill = (form_name, name, value, other) => {
    setState(prevState => ({
      [form_name]: {
        ...prevState[form_name],
        [name]: value,
        ...other,
      },
    }));
  };

  const handleLfdcFormContentFill = (name, value) => {
    const other = value
      ? (name == "sanitize" ? { update_intents: false }
         : name == "update_intents" ? { sanitize: false } : {})
      : {};
    handleNestedFormContentFill('dcImportConfig', name, value, other);
  };

  const handleLfsaFormContentFill = (name, value) => {
    handleNestedFormContentFill('saImportConfig', name, value);
  };

  const loadFromDialogComposerForm = (t, classes) => {
    return (
      <FormControl fullWidth component="fieldset">
        <DateTimeRange
          state={dcImportConfig}
          handleChange={handleLfdcFormContentFill}
          classes={classes}
          lang={lang}
        />
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <NumberField
            label={t("datasets.max_size")}
            className={classes.smallTextField}
            style={{ marginLeft: 0 }}
            value={dcImportConfig.maxSize}
            inputProps={{min: 1}}
            onChange={event => handleLfdcFormContentFill("maxSize", event.target.value)}
          />
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.intent_slot")}
            checked={state.intentSlotChecked}
            onChange={(event) => {
              const check = event.target.checked;
              setState((prevState) => ({
                intentSlotChecked: check,
                dcImportConfig: {
                  ...prevState.dcImportConfig,
                  intent_slot: check ? "dummy" : '',
                },
              }));
            }}
          />
          {state.intentSlotChecked ?
            <TextField
              required
              className={classes.smallTextField}
              style={{marginTop: 0}}
              defaultValue={dcImportConfig.intent_slot || ""}
              size="small"
              onChange={(event) => {
                handleLfdcFormContentFill("intent_slot", event.target.value);
              }}
              type="string"
              variant="outlined"
              fullWidth
            /> : null}
        </FormGroup>
        {isMaybeNLU(project) && <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.update_intents")}
            checked={dcImportConfig.update_intents}
            onChange={(event) =>
                handleLfdcFormContentFill("update_intents", event.target.checked)
            }
          />
        </FormGroup>}
        {isMaybeASR(project) && <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.check_audio")}
            checked={dcImportConfig.check_audio}
            onChange={(event) =>
                handleLfdcFormContentFill("check_audio", event.target.checked)
            }
          />
        </FormGroup>}
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.sanitize")}
            checked={dcImportConfig.sanitize}
            onChange={(event) =>
                handleLfdcFormContentFill("sanitize", event.target.checked)
            }
          />
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.ani")}
            checked={state.aniChecked}
            onChange={(event) => {
              setState({ aniChecked: event.target.checked });
              handleLfdcFormContentFill("ani", '');
            }}
          />
          {state.aniChecked ? <TextField
            className={classes.smallTextField}
            style={{marginTop: 0}}
            defaultValue={dcImportConfig.ani}
            size="small"
            onChange={(event) =>
                handleLfdcFormContentFill("ani", event.target.value)
            }
            type="string"
            variant="outlined"
            fullWidth
          /> : null}
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <FormControlLabel
            className={classes.checkboxStart}
            control={<Checkbox/>}
            label={t("datasets.channel")}
            checked={state.channelChecked}
            onChange={(event) => {
              setState({ channelChecked: event.target.checked });
              handleLfdcFormContentFill("channel", '');
            }}
          />
          {state.channelChecked ?
            <TextField
              className={classes.smallTextField}
              style={{marginTop: 0}}
              defaultValue={dcImportConfig.channel}
              size="small"
              onChange={(event) =>
                  handleLfdcFormContentFill("channel", event.target.value)
              }
              type="string"
              variant="outlined"
              fullWidth
            /> : null}
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow} style={{justifyContent: 'space-between'}}>
          <RadioGroup
            className={classes.radioGroup}
            labels={['first','all'].reduce((a,k) => {a[k]=t('datasets.utterance_'+k); return a}, {})}
            value={dcImportConfig.first ? "first" : "all"}
            onChange={event => handleLfdcFormContentFill("first", event.target.value == "first")}
            legend={{name: t("datasets.utterances"), classes: classes.checkboxLabelBeforeRadio}}
          />
          <FormControlLabel
            control={<Checkbox/>}
            label={t(`datasets.glue_utterances`)}
            checked={dcImportConfig.glue}
            onChange={event => handleLfdcFormContentFill("glue", event.target.checked)}
          />
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <RadioGroup
            className={classes.radioGroup}
            labels={['none','auto','manual'].reduce((a,k) => {a[k]=t('datasets.'+k); return a}, {})}
            value={dcImportConfig.status}
            onChange={event => handleLfdcFormContentFill("status", event.target.value)}
            legend={{name: t("datasets.annotation"), classes: classes.checkboxLabelBeforeRadio}}
          />
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <ImportFromDCSettings
            id='composer'
            fields={['url', 'applicationId']}
            settings={state.dcImportConfig}
            setSettings={name => data => {
              setState({ dcImportConfig: { ...state.dcImportConfig, [name]: data.target.value } })
            }}
            fieldProps={{url: {style: {width: '100%'}}}}
          />
        </FormGroup>
      </FormControl>
    );
  };

  const loadFromSpeechAnalyticsForm = (t, classes) => {
    return (
      <FormControl fullWidth component="fieldset">
        <DateTimeRange
          state={saImportConfig}
          handleChange={handleLfsaFormContentFill}
          classes={classes}
          lang={lang}
        />
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <NumberField
            label={t("datasets.max_size")}
            className={classes.smallTextField}
            style={{ marginLeft: 0 }}
            value={saImportConfig.maxSize}
            inputProps={{min: 1}}
            onChange={event => handleLfsaFormContentFill("maxSize", event.target.value)}
          />
        </FormGroup>
        <FormGroup className={classes.editLoadFromDCParamsRow}>
          <ImportFromSASettings
            id='analytics'
            fields={['url', 'projectId', ...(config.enableImportFromDC ? ['token'] : [])]}
            settings={saImportConfig}
            setSettings={name => data => {
              setState({ saImportConfig: { ...saImportConfig, [name]: data.target.value } })
            }}
            fieldProps={{url: {style: {width: '100%'}}}}
          />
        </FormGroup>
      </FormControl>
    )
  };

  return (
    <>
        <TabPanel index={0} value={tabValue}>
          <div style={{ height: radioValueFileType == "json" ? 255 : is_proj_gen ? 315 : 415, overflowY: "auto" }}>
            <div style={{ marginBottom: 20, width: "100%", display: "flex" }}>
              <RadioGroup
                style={{ marginLeft: -16, width: "100%" }}
                name="position"
                labels={{json: "JSON", csv: "CSV"}}
                value={radioValueFileType}
                onChange={handleChangeSwitch}
              />
            </div>
            <div style={{ marginBottom: 20, textAlign: "left" }}>
              <Upload
                btnLabel={t('common.choose_file')}
                onFileLoad={onFileLoad}
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <RadioGroup
                name="annotation"
                className={classes.radioGroup}
                labels={['none','auto','manual'].reduce((a,k) => {a[k]=t('datasets.'+k); return a}, {})}
                value={state.annStatus}
                onChange={event => setState({ annStatus: event.target.value })}
                legend={{name: t("datasets.annotation"), classes: classes.checkboxLabelBeforeRadio}}
              />
              {radioValueFileType === "csv" && (
                <>
                  <div style={{ display: "flex" }}>
                    <FormLabel
                      className={classes.checkboxLabelBeforeText}
                      component="legend"
                    >
                      {t("datasets.separator")} *
                    </FormLabel>
                    <div>
                      <div style={{ display: "flex" }}>
                        <TextField
                          required
                          size="small"
                          className={classes.smallTextField}
                          id="csvSeparator"
                          onChange={(event) =>
                              setState({ csvSeparator: event.target.value })
                          }
                          variant="outlined"
                          fullWidth
                          defaultValue={state.csvSeparator}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <FormLabel
                      className={classes.checkboxLabelBeforeText}
                      component="legend"
                    >
                      {t("datasets.fields")}
                    </FormLabel>
                    <div>{(() => {
                      const FIELDS = {
                        ...(is_proj_asr ? {
                          audio:      'csvAudio'
                        } : {}),
                        ...(is_proj_gen ? {
                          input:      'csvInputField',
                          output:     'csvOutputField',
                          ext_id:     'csvExtIdField',
                        } : {
                          utterance:  'csvUtterance',
                          ...(is_proj_asr ? {} : {
                              intent:     'csvIntentField',
                          }),
                        }),
                        confidence: 'csvConfidence',
                        ...(is_proj_gen && !is_proj_asr ? {} : {
                          audio:      'csvAudio'
                        }),
                      };
                      return (
                        <div style={{ display: "flex" }}>
                          {Object.entries(FIELDS).map(([name, field]) => (
                            <TextField
                              key={name}
                              required={name == (is_proj_asr ? 'audio' : is_proj_gen ? 'input' : 'utterance')}
                              size="small"
                              className={classes.smallTextField}
                              id={field}
                              label={t("datasets."+ name)}
                              onChange={event => setState({ [field]: event.target.value })}
                              variant="outlined"
                              fullWidth
                              defaultValue={state[field]}
                            />))}
                        </div>
                      )})()}
                    </div>
                  </div>
                  <FormControlLabel
                    style={{ marginTop: 13, height: "auto" }}
                    control={
                      <Checkbox
                        checked={state.header}
                        onChange={() => setState(prevState => ({ header: !prevState.header }))}
                      />
                    }
                    label={t("datasets.fist_row_is_header")}
                  />
                </>
              )}
            </div>
            <UploadProperties
              {...{ state, handleUploadPropertiesChange, is_proj_gen }}
            />
          </div>
        </TabPanel>
        <TabPanel index={1} value={tabValue}>
          {loadFromDialogComposerForm(t, classes)}
        </TabPanel>
        <TabPanel index={2} value={tabValue}>
          {loadFromSpeechAnalyticsForm(t, classes)}
        </TabPanel>
        {getRunConfigOption('copyDatasetTab') && rowId ? 
          <TabPanel index={3} value={tabValue}>
            {Object.keys(copyProps)
                .map(name => (
                  <FormControlLabel
                    key={name}
                    control={
                      <Checkbox
                        checked={copyProps[name]}
                        onChange={handleCopyPropertiesChange}
                        name={name}
                      />
                    }
                    label={t("datasets."+ name)}
                  />
                ))}
            <FormControl component="fieldset">
              <FormGroup>
                {Object.keys(state.copySlice)
                    .map(name => (
                      <NumberField
                        key={name}
                        label={t("datasets.slice_"+ name)}
                        className={classes.smallTextField}
                        style={{ marginTop: 10, width: '100%' }}
                        value={state.copySlice[name]}
                        inputProps={{min: 0}}
                        onChange={event => handleCopySliceFill(name, event.target.value)}
                      />
                    ))}
              </FormGroup>
            </FormControl>
          </TabPanel> : null
        }
      </>
  );
};

function DatasetSimilaritySettings({
  nluConfigServer, setNLUConfigServer, settings, setSettings,
  state, setState, backends, projectId, projects, menuItemKey,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const project = getProject(projects, projectId);

  const simConfig = state.similarityConfig || {};
  const server = simConfig.nlu_backend ? backends?.find(b => b._id == simConfig.nlu_backend)?.url : simConfig.server;

  return (
    <div style={{ marginTop: 20 }}>
      <BackendSettings
        id='nlu'
        typeOfInput="autocomplete"
        fields={["train_url"]}
        settings={{ ...simConfig, train_url: server }}
        setSettings={() => (_, value) => {
          setState({ ...state, similarityConfig: { ...simConfig, nlu_backend: value._id }})
        }}
        fieldDescr={{ 
          train_url: {
            type: 'nb_server',
            // props: { id: "nlu_backend", label_key: "train_url" },
            classes: classes.similarityConfigServerURL,
            onChange: setNLUConfigServer,
            info: true,
            classes_info: classes.similarityConfigServerURL,
            new_name: 'nlu_backend',
          }
        }}
        backends={backends}
      />
      <SimilaritySettings
        menuItemKey={menuItemKey}
        settings={simConfig}
        setSettings={(name, opts = {}) => data => {
          const value_obj = opts.is_direct ? data : { [name]: data.target.value };
          setState({ ...state, similarityConfig: { ...simConfig, ...value_obj }})
        }}
        server={nluConfigServer}
      />
    </div>
  );
}

function DatasetAutoanntnSettings({ setNLUConfigServer, state, setState, backends, menuItemKey }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [genConfDetails, setGenConfDetails] = useState();

  const autoConfig = state.autoannotnConfig || {};
  const setAutoConfig = value => {
    setState({ ...state, autoannotnConfig: { ...autoConfig, ...value }})
  };

  const server = backends?.find(b => b._id == autoConfig.nlu_backend)?.url;

  return (
    <div style={{ marginTop: 20 }}>
      <BackendSettings
        id='nlu'
        typeOfInput="autocomplete"
        fields={["train_url"]}
        settings={{ ...autoConfig, train_url: server }}
        setSettings={() => (_, value) => setAutoConfig({ nlu_backend: value._id })}
        fieldDescr={{ 
          train_url: {
            type: 'nb_server',
            classes: classes.similarityConfigServerURL,
            onChange: setNLUConfigServer,
            info: true,
            classes_info: classes.similarityConfigServerURL,
            new_name: 'nlu_backend',
          }
        }}
        backends={backends}
      />
      <SelectModel
        menuItemKey={menuItemKey}
        settings={autoConfig}
        onChange={(event, value) => setAutoConfig({ model: value })}
        modelInfo={genConfDetails}
        setModelInfo={setGenConfDetails}
        EMPTY_MODEL_INFO={EMPTY_GEN_CONFIG_DETAILS}
        url={server && `/api/settings/similarity_config_details?server=${server}`}
        getModelInfoFromResponse={data => data.similarity_config_details} // TODO: data.autoanntn_config_details
        getOptions={modelInfo => Object.keys(modelInfo?.models || {})}
        getValue={modelInfo => modelInfo?.models[autoConfig.model] && autoConfig.model || null}
      />
    </div>
  );
}

const EMPTY_GEN_CONFIG_DETAILS = { models: {} };

function DatasetGenerateSettings({ setNLUConfigServer, state, setState, projectDatasets, backends, projectId, projects, menuItemKey }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [genConfDetails, setGenConfDetails] = useState();
  const [dataset, setDataset] = useState();

  const project = getProject(projects, projectId);

  const genConfig = state.generationConfig || {};
  const setGenConfig = value => {
    setState({ ...state, generationConfig: { ...state.generationConfig, ...value }})
  };

  const server = genConfig.nlu_backend ? backends?.find(b => b._id == genConfig.nlu_backend)?.url : genConfig.server;

  return (
    <div style={{ marginTop: 20 }}>
      <BackendSettings
        id='nlu'
        typeOfInput="autocomplete"
        fields={['train_url']}
        settings={{ ...genConfig, train_url: server }}
        setSettings={() => (_, value) => {
          setGenConfig({ nlu_backend: value._id });
        }}
        fieldDescr={{
          train_url: {
            type: "nb_server",
            props: { id: "nlu_backend", label_key: "train_url" },
            classes: classes.similarityConfigServerURL,
            onChange: setNLUConfigServer,
            info: true,
            classes_info: classes.similarityConfigServerURL,
            new_name: 'nlu_backend',
          },
        }}
        backends={backends}
      />
      <SelectModel
        menuItemKey={menuItemKey}
        settings={genConfig}
        onChange={(event, value) => setGenConfig({ model: value })}
        modelInfo={genConfDetails}
        setModelInfo={setGenConfDetails}
        EMPTY_MODEL_INFO={EMPTY_GEN_CONFIG_DETAILS}
        url={server && `/api/settings/similarity_config_details?server=${server}&is_gen=true`}
        getModelInfoFromResponse={data => data.similarity_config_details} // TODO: data.generation_config_details
        getOptions={modelInfo => Object.keys(modelInfo?.models || {})}
        getValue={modelInfo => modelInfo?.models[genConfig.model] && genConfig.model || null}
      />
      <Autocomplete
        label={t("common.dataset")}
        className={classes.textField}
        style={{marginTop: 20}}
        options={projectDatasets}
        getOptionLabel={d => d.name}
        value={projectDatasets.find(d => d._id == genConfig.dataset) || null}
        onChange={(event, value) => setGenConfig({ dataset: value?._id })}
      />
    </div>
  );
}

function ImportFromTest({ state, setState, projectId, is_proj_gen }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [_tests, setTests] = useState([]);

  const getTests = () =>
    getData('/api/testmodel?project='+ projectId, dispatch, data => setTests(data.testmodels));

  useEffect(() => { getTests() }, []);

  const tests = _tests.filter(t => is_proj_gen ? getTestModelGenvAcc(t) != undefined
                              : (getTestModelIntentAcc(t) != undefined
                                 || getTestModelSlotAcc(t) != undefined));

  const handleCheckboxChange = (event, key) => {
    setState({
      [key]: {
        ...state[key],
        [event.target.name]: event.target.checked,
      },
    });
  };

  const handleUploadPropertiesChange = (event) => {
    handleCheckboxChange(event, 'uploadProperties');
  };

  return (<>
    <Autocomplete
      style={{ marginTop: 10 }}
      label={t('datasets.test')}
      options={tests}
      getOptionLabel={t => t.name}
      value={tests.find(t => t._id == state.testId) || null}
      onChange={(_, t) => setState({ testId: t?._id })}
    />
    <UploadProperties
      {...{ state, handleUploadPropertiesChange, only: qw`update_intents`, is_proj_gen }}
    />
  </>);
}

const mapStateToProps = (state) => ({
  projects: state.settings.projects,
  projectId: state.settings.projectId,
  projectDatasets: state.settings.projectDatasets,
  lang: state.settings.lang,
});

export default connect(mapStateToProps)(withStyles(styles)(EditDialog));
